<div (click)="showFn()" class="hoverCursor">
  <i class="far fa-bell fa-lg whiteColor">
    <span class="postionBadge badge badge-danger" *ngIf="this.newNotityCount > 0">{{this.newNotityCount}}</span>
  </i>
</div>

<div id="notifyDiv" class="dropdown-menu dropdown-menu-lg dropdown-menu-right py-0 show mt-2 mr-4"
  aria-labelledby="messagesDropdown">
  <div class="dropdown-menu-header">
    <div class="position-relative">
      <span *ngIf="this.newNotityCount > 0">{{this.newNotityCount}} New </span> Notifications
    </div>
  </div>
  <div class="list-body">

    <div class="text-center" *ngIf="this.notifyData?.length == 0">No message</div>

    <div class="list-group hoverCursor" *ngFor="let notify of notifyData;let i = index;">
      <a class="list-group-item NewQuery" (click)="openChatFn(notify);showFn();">
        <!-- *ngIf="notify?.status==='New'" -->
        <div class="row no-gutters align-items-center">
          <div class="col-2">
            <i class="far fa-question-circle NewQuery"></i>
          </div>
          <div class="col-10 pl-2">
            <div class="text-dark">{{notify?.name}}</div>
            <div class="text-muted small mt-1">{{notify?.message}}</div>
            <div class="text-muted small mt-1">{{notify?.enquiryOn | date:'MMMM d, y hh:mm:ss'}}</div>
          </div>
        </div>
      </a>
      <!-- <a class="list-group-item Pending" (click)="openChatFn(notify);showFn(this.show);"
        *ngIf="notify?.status==='Read'">
        <div class="row no-gutters align-items-center">
          <div class="col-2">
            <i class="fas fa-history Pending"></i>
          </div>
          <div class="col-10 pl-2">
            <div class="text-dark">{{notify?.name}}</div>
            <div class="text-muted small mt-1">{{notify?.message}}</div>
            <div class="text-muted small mt-1">{{notify?.enquiryOn | date:'MMMM d, y'}}</div>
          </div>
        </div>
      </a> -->
      <!-- <a href="#" class="list-group-item">
                <div class="row no-gutters align-items-center">
                    <div class="col-10 pl-2">
                        <div class="text-dark">Stacie Hall</div>
                        <div class="text-muted small mt-1">Pellentesque auctor neque nec urna.</div>
                        <div class="text-muted small mt-1">4h ago</div>
                    </div>
                </div>
            </a>
            <a href="#" class="list-group-item">
                <div class="row no-gutters align-items-center">
                    <div class="col-10 pl-2">
                        <div class="text-dark">Bertha Martin</div>
                        <div class="text-muted small mt-1">Aenean tellus metus, bibendum sed, posuere ac, mattis non.</div>
                        <div class="text-muted small mt-1">5h ago</div>
                    </div>
                </div>
            </a> -->
    </div>
  </div>
  <!-- <div class="dropdown-menu-footer">
            <a href="#" class="text-muted">Show all messages</a>
        </div> -->
</div>
